module.exports = __webpack_public_path__ + "static/media/instagram.fc1f37f8.svg";